<div class="align-top">
    <section class="info-box">
        <h2 class="info-box-title">{{'auth.emergencyLogin.noActiveUserCertificatesFound.title' | translate}}</h2>
        <p class="info-box-text">{{'auth.emergencyLogin.noActiveUserCertificatesFound.text' | translate}}</p>
        <div class="instructions-box">
            <h3 class="instructions-box-title">{{'auth.emergencyLogin.noActiveUserCertificatesFound.instructions.title' | translate}}</h3>
            <ol class="instructions-list">
                <li>{{'auth.emergencyLogin.noActiveUserCertificatesFound.instructions.step1' | translate}}</li>
                <li>{{'auth.emergencyLogin.noActiveUserCertificatesFound.instructions.step2' | translate}}</li>
                <li>{{'auth.emergencyLogin.noActiveUserCertificatesFound.instructions.step3' | translate}}</li>
            </ol>
    </div>
        <div class="goBack-button">
            <button type="button" mat-raised-button class="goBack-btn" (click)="goBack()">
                {{'auth.emergencyLogin.noActiveUserCertificatesFound.goBack' | translate}}
            </button>
        </div>
    </section>
</div>
